// 一些异步获取的字典数据
import {getCategoryOptions} from '@/servers/prod/center'
import { getJdWareLocationList } from '@/servers/prod/center/jd'
import { queryLevelList } from '@/api/supplier/index'

const dictionary = {
  state: () => ({
    category: [], // 可用类目数据
    jdWareLocation: [], // 京东平台的产地数据
    distributionLevelList: [], // 分销等级
    joinOcean:true, // 共享分销小店商品 配置
  }),
  mutations: {
    setCategory (state, category) {
      state.category = category
    },
    setJdWareLocation (state, list) {
      state.jdWareLocation = list
    },
    setDistributionLevelList (state, list) {
      state.distributionLevelList = list
    },
    setJoinOcean(state, joinOcean) {
      state.joinOcean = joinOcean
    }
  },
  actions: {
    getCategory({commit}) {
      getCategoryOptions().then(options => {
        commit("setCategory", options ? options : [])
      }).catch(err => console.log('actions-getCategory-error!###', err))
    },
    getJdWareLocation({commit}) {
      getJdWareLocationList().then(options => {
        commit("setJdWareLocation", options ? options : [])
      }).catch(err => console.log('actions-getJdWareLocation-error!###', err))
    },
    getLevels({commit, state}) {
      // if (state.distributionLevelList.length) return console.log("已加载过分销等级");
      queryLevelList().then(res => {
        const data = res.data?.data || [];
        let options = data.map(item => {
          return { label:item.name, value: item.level }
        })
        options = options.sort((a, b) => a.value - b.value);
        commit("setDistributionLevelList", options)
      }).catch(err => console.log('actions-getLevels-error!###', err))
    },
    joinOcean({commit}, joinOcean) {
      commit("setJoinOcean", joinOcean)
    }
  },
  getters: {
    dictionary_category(state) {
      return state.category.map(item => {
        return {label: item.name, value: item.cid, leaf: item.leaf}
      })
    },
    baseCascaderCategory(state) {
      return state.category
    },
    jd_wareLocation(state) {
      return state.jdWareLocation
    },
    distributionLevelList(state) {
      return state.distributionLevelList
    },
    getJoinOcean(state) {
      return state.joinOcean
    }
  }
}

export default dictionary
